import React, { useEffect } from 'react'
import { Alert, Button, Form, Input } from 'antd'
import ConceptualLabelSelectDisciplines from '../select/ConceptualLabelSelectDisciplines'
import ConceptualLabelSelectParent from '../select/ConceptualLabelSelectParent'
import ConceptualLabelSelectType from '../select/ConceptualLabelSelectType'

const { TextArea } = Input

const ConceptualLabelForm = ({
    onSubmit,
    initialValues,
    error,
    loading,
    formResetTrigger,
    submitButtonText = 'Submit',
}) => {
    const [form] = Form.useForm()

    useEffect(() => {
        form.resetFields()
    }, [form, formResetTrigger])

    return (
        <Form
            form={form}
            name='conceptual-label-form'
            autoComplete='off'
            onFinish={onSubmit}
            requiredMark={false}
            layout='vertical'
        >
            <Form.Item
                name='name'
                label='Name'
                initialValue={initialValues?.name}
                rules={[{ required: true, message: 'Please enter the name' }]}
            >
                <Input placeholder='Enter name' />
            </Form.Item>
            <Form.Item
                name='typeId'
                label='Type'
                initialValue={initialValues?.typeId}
                rules={[{ required: true, message: 'Please select a type' }]}
            >
                <ConceptualLabelSelectType />
            </Form.Item>
            <Form.Item
                name='description'
                label='Description'
                initialValue={initialValues?.description}
            >
                <TextArea rows={4} placeholder='Enter description' />
            </Form.Item>
            <Form.Item
                name='disciplineId'
                label='Discipline'
                initialValue={initialValues?.disciplineId}
                rules={[{ required: true, message: 'Please select a discipline' }]}
            >
                <ConceptualLabelSelectDisciplines />
            </Form.Item>
            <Form.Item
                name='source'
                label='Source'
                initialValue={initialValues?.source}
                rules={[{ required: true, message: 'Please enter the source' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name='parentId'
                label='Parent'
                initialValue={initialValues?.parentId}
            >
                <ConceptualLabelSelectParent />
            </Form.Item>
            
            {error && <Alert message={error} type='error' showIcon closable />}
            <Form.Item>
                <Button type='primary' htmlType='submit' block loading={loading}>
                    {submitButtonText}
                </Button>
            </Form.Item>
        </Form>
    )
}

export default ConceptualLabelForm
